/**
 * Projects kept off the site even though the REM feed still lists them.
 *
 * The feed is the developers' inventory, not ours, so it cannot be edited.
 * To hide a project, add its id — the number in /project/<id> — with a note
 * saying why and when. To bring it back, delete the line.
 *
 * Enforced everywhere project data enters the site:
 *   api/proxy.js            — every browser request in production
 *   src/services/api.js     — the Vite dev server, which bypasses the proxy
 *   api/chat.js             — the AI advisor's search and detail tools
 *   scripts/lib/rem.mjs     — prerendered pages, area pages and the sitemap
 *
 * Plain JS with no imports, because the serverless functions, the build
 * scripts and the browser bundle all load it.
 */
export const HIDDEN_PROJECTS = {
    3370: 'Hidden at the client\'s request, 15 Oct 2026'
};

export function isHiddenProjectId(id) {
    return id != null && id !== '' && Object.prototype.hasOwnProperty.call(HIDDEN_PROJECTS, String(id));
}

export const isHiddenProject = (project) => isHiddenProjectId(project?.id);

/**
 * A REM list response with hidden projects removed and `total` adjusted, so
 * pagination does not promise a project that never arrives.
 */
export function stripHiddenFromList(json) {
    const rows = json?.data?.data;
    if (!Array.isArray(rows)) return json;
    const kept = rows.filter((row) => !isHiddenProject(row));
    const removed = rows.length - kept.length;
    if (!removed) return json;
    return {
        ...json,
        data: {
            ...json.data,
            data: kept,
            ...(typeof json.data.total === 'number' && { total: Math.max(0, json.data.total - removed) })
        }
    };
}

/** What a detail request for a hidden project answers: the same as a missing one. */
export const HIDDEN_DETAIL_RESPONSE = { status: false, message: 'Project not found', data: null };
